import { gql } from '@apollo/client';

export const CREATE_ACCESS_CODE = gql`
    mutation CreateAccessCode($input: CreateAccessCodeInput!) {
        pcCreateAccessCode(input: $input) {
            success
            resultType
        }
    }
`;

export const UPDATE_ACCESS_CODE = gql`
    mutation UpdateAccessCode($input: UpdateAccessCodeInput!) {
        pcUpdateAccessCode(input: $input) {
            success
            resultType
        }
    }
`;
/**
 * 删除门禁code
 * 需在 api-server AccessCodeMutation 中实现 deleteAccessCode(accessCodeId: Long!): Boolean
 */
export const DELETE_ACCESS_CODE = gql`
    mutation DeleteAccessCode($accessCodeId: Long!, $orderId: Long) {
        pcDeleteAccessCode(accessCodeId: $accessCodeId, orderId: $orderId)
    }
`;

export interface AccessCodeInput {
    id: number;
    codeType: string;
    accessCode: string | null;
    status?: number | null;
}

export interface CreateAccessCodeInput {
    orderId: number;
    codeType: string;
    accessCode: string;
    latitude?: number | null;
    longitude?: number | null;
}

export interface UpdateAccessCodeInput {
    orderId?: number | null;
    accessCode: AccessCodeInput;
    latitude?: number | null;
    longitude?: number | null;
}

export interface AccessCodeOperationResult {
    success: boolean;
    resultType: string;
}

export interface CreateAccessCodeResponse {
    pcCreateAccessCode: AccessCodeOperationResult;
}

export interface UpdateAccessCodeResponse {
    pcUpdateAccessCode: AccessCodeOperationResult;
}

export interface CreateAccessCodeVariables {
    input: CreateAccessCodeInput;
}

export interface UpdateAccessCodeVariables {
    input: UpdateAccessCodeInput;
}


export interface DeleteAccessCodeResponse {
    deleteAccessCode: boolean;
}

export interface DeleteAccessCodeVariables {
    accessCodeId: number;
    orderId?: number;
}

export const SAVE_PC_ACCESS_CODE_QUERY_LOG = gql`
    mutation SavePcAccessCodeQueryLog($accessCodeId: Long!) {
        savePcAccessCodeQueryLog(accessCodeId: $accessCodeId)
    }
`;

export interface SavePcAccessCodeQueryLogResponse {
    savePcAccessCodeQueryLog: boolean;
}

export interface SavePcAccessCodeQueryLogVariables {
    accessCodeId: number;
}